module.exports = "/_next/static/images/OgImage-7855d49bf1ace212e7feabd5964a0350.jpeg";